module.exports = __webpack_public_path__ + "static/media/NAFIL_logoCurto.66b95ea2.svg";